import React, {
  Component,
} from 'react'
import debounce from 'lodash/debounce'
import PropTypes from 'prop-types'
import Formsy from 'formsy-react'
import Wrapper from 'components/wrappers/Wrapper'
import { convertNumericValue } from 'helpers/objectHelpers'
import FormLabel from '../labels/FormLabel'
import FormsyInput from './FormsyInput'

const fieldStyles = {
  base: { position: 'absolute' },
  top: {
    top: '10%',
    left: '35%',
  },
  left: {
    left: 0,
    top: '35%',
  },
  right: {
    right: 0,
    top: '35%',
  },
  bottom: {
    bottom: '10%',
    left: '35%',
  },
}

const inputStyles = {
  base: { width: 100 },
  left: { marginLeft: 45 },
  right: { marginRight: 45 },
}

class FormsySpacing extends Component {
  constructor() {
    super()
    this.handleChange = debounce(this.handleChange.bind(this), 100)
  }

  handleChange() {
    if (this.form) {
      const model = this.form.getModel()
      const resolvedModel = convertNumericValue(model, this.props.prefix)
      this.props.onChange(resolvedModel)
    }
  }

  render() {
    const {
      label,
      top = '',
      bottom = '',
      left = '',
      right = '',
    } = this.props
    return (
      <Wrapper.Panel
        padding={1}
        mb={1}
        css={{
          position: 'relative',
          height: '270px',
          width: '100%',
        }}
      >
        <FormLabel dark>{label}</FormLabel>
        <Formsy.Form
          ref={(form) => this.form = form}
          onValid={this.handleChange}
        >
          <FormsyInput.UnitSize
            name={'top'}
            floatingLabelText={'Top'}
            value={top}
            style={{
              ...fieldStyles.base,
              ...fieldStyles.top,
              ...inputStyles.base,
            }}
          />
          <FormsyInput.UnitSize
            name={'left'}
            floatingLabelText={'Left'}
            value={left}
            style={{
              ...fieldStyles.base,
              ...fieldStyles.left,
              ...inputStyles.base,
              ...inputStyles.left,
            }}
          />
          <FormsyInput.UnitSize
            name={'right'}
            floatingLabelText={'Right'}
            value={right}
            style={{
              ...fieldStyles.base,
              ...fieldStyles.right,
              ...inputStyles.base,
              ...inputStyles.right,
            }}
          />
          <FormsyInput.UnitSize
            name={'bottom'}
            floatingLabelText={'Bottom'}
            value={bottom}
            style={{
              ...fieldStyles.base,
              ...fieldStyles.bottom,
              ...inputStyles.base,
              ...inputStyles.bottom,
            }}
          />
        </Formsy.Form>
      </Wrapper.Panel>
    )
  }
}

FormsySpacing.propTypes = {
  prefix: PropTypes.string,
  onChange: PropTypes.func,
}
FormsySpacing.defaultProps = {
  prefix: '',
  onChange: () => {},
}

export default FormsySpacing



// WEBPACK FOOTER //
// ./src/components/formsy/FormsySpacing.js